import { useMemo, type PropsWithChildren } from 'react';

import { EntityType } from 'utils/enums';

import Badge from 'shared/components/Badge';
import useSelector from 'shared/hooks/useSelector';

interface NotificationBadgeProps {
  className?: string;
  entityType: EntityType;
  entityId: string;
}

function NotificationBadge(props: PropsWithChildren<NotificationBadgeProps>) {
  const { children, entityId, entityType } = props;

  const { info } = useSelector((state) => state.notifications[entityType]);

  const notifications = useMemo(
    () => info.find((item) => item.EntityId === entityId),
    [info, entityId]
  );

  return <Badge badgeContent={notifications?.NewMessages}>{children}</Badge>;
}

export default NotificationBadge;
